/**
 * SEO constants and helpers for the PUBLIC marketing pages.
 *
 * Only routes listed in PUBLIC_PATHS receive canonical/og/twitter tags.
 * Every other route (authenticated app, admin, auth flows) is marked
 * noindex so it can never be indexed.
 */

export const SITE_URL = 'https://lanerunner.com';

/** Stable, publicly hosted social preview image (1200x630). */
export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/og-preview.png`;

/** Public marketing / legal pages that should be indexed. */
export const PUBLIC_PATHS = new Set<string>([
  '/',
  '/load-board',
  '/brokers',
  '/carriers',
  '/shippers',
  '/pricing',
  '/partner-program',
  '/lr-direct-access',
  '/investors',
  '/affiliates',
  '/privacy',
  '/terms',
  '/cancellation-policy',
  '/cookies',
  '/cookie-policy',
]);

export const isPublicPath = (pathname: string) =>
  PUBLIC_PATHS.has(pathname.replace(/(.)\/+$/, '$1'));

export const absoluteUrl = (pathname: string) =>
  `${SITE_URL}${pathname === '/' ? '/' : pathname.replace(/\/+$/, '')}`;
